<template>
  <div class="account-setting">
    <Navbar title="设置"></Navbar>
    <div class="user-info">
      <van-cell-group>
        <van-field
          v-model="telephone"
          label="门店电话"
          placeholder="请输入门店电话"
        />
        <van-cell title="门店定位" is-link @click="handleAdress" />
        <van-cell title="详细地址" :value="userInfo.dealerAddress" />
        <van-cell title="当前账号" :value="userInfo.phone" />
        <van-cell title="切换账号" is-link @click="handleUnbindWx" />
        <!-- <van-cell title="退出" value="" @click="handleLogout" /> -->
      </van-cell-group>
    </div>
    <van-button type="primary" @click="handleSave">保存</van-button>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import Navbar from "@/components/Navbar.vue";
import { logout, updateDealer, userInfo } from "@/api/user";
import { Dialog } from "vant";

export default {
  components: {
    Navbar,
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      userDate: {
        address: "",
        province: "",
        city: "",
        district: "",
        longitude: "",
        latitude: "",
      },
      telephone: JSON.parse(sessionStorage.getItem("userInfo")).dealerTelephone,
    };
  },
  mounted() {
    console.log(JSON.parse(sessionStorage.getItem("userInfo")));
    if (this.$route.query.latng) {
      this.handleLatng(this.$route.query.latng);
    }
  },
  methods: {
    // 地图选点
    handleAdress() {
      window.location.href = `https://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl=${this.$userAdress}&key=OG4BZ-GTFW6-TVPS5-EOESI-BR7GV-7KFYZ&referer=myapp`;
    },
    // 经纬度解析
    handleLatng(latng) {
      this.$jsonp(
        `https://apis.map.qq.com/ws/geocoder/v1/?location=${latng}&key=OG4BZ-GTFW6-TVPS5-EOESI-BR7GV-7KFYZ`,
        {
          callbackName: "QQmap",
          output: "jsonp",
        }
      )
        .then((json) => {
          console.log("经纬度解析 :>> ", json.result);
          let address_component = json.result.address_component;
          let location = json.result.location;
          this.userDate.province = address_component.province;
          this.userDate.city = address_component.city;
          this.userDate.district = address_component.district;
          // this.userDate.address = json.result.address;
          this.userDate.address = address_component.street;
          this.userInfo.dealerAddress = json.result.address;
          this.userDate.longitude = location.lng;
          this.userDate.latitude = location.lat;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 更新经销商地址
    handleUpdateDealer() {
      updateDealer(this.userDate).then((res) => {
        // console.log("更新经销商资料 :>> ", res);
        if (res.code === 0) {
          userInfo().then((res) => {
            // console.log("经销商资料 :>> ", res);
            this.$toast("已保存");
            this.userInfo = res.result;
            sessionStorage.setItem("userInfo", JSON.stringify(res.result));
          });
        }
      });
    },
    // 更新经销商电话
    handleUpdatePhone() {
      updateDealer({ telephone: this.telephone }).then((res) => {
        // console.log("更新经销商资料 :>> ", res);
        if (res.code === 0) {
          userInfo().then((res) => {
            // console.log("经销商资料 :>> ", res);
            this.$toast("已保存");
            this.userInfo = res.result;
            sessionStorage.setItem("userInfo", JSON.stringify(res.result));
          });
        }
      });
    },
    // 注销
    handleLogout() {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定退出?",
      }).then(() => {
        logout().then((res) => {
          if (res.code === 0) {
            localStorage.removeItem("myToken");
            wx.closeWindow();
          }
        });
      });
    },
    // 解绑微信
    handleUnbindWx() {
      Dialog.confirm({
        title: "温馨提示",
        message: "该操作将会解绑微信并退出账户,确定继续?",
      }).then(() => {
        sessionStorage.clear();
        localStorage.clear();
        // wx.closeWindow();
        this.$router.replace({
          path:"/login"
        })
        // unbindWx().then((res) => {
        //   if (res.code === 0) {
        //     localStorage.removeItem("myToken");
        //     wx.closeWindow();
        //   }
        // });

      });
    },
    // 保存
    handleSave() {
      if (this.userDate.latitude) {
        this.handleUpdateDealer();
      }
      if (this.telephone) {
        this.handleUpdatePhone();
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
<style lang="scss">
.account-setting {
  .user-info {
    margin-bottom: 20px;

    .van-field__control {
      text-align: right;
    }

    .van-cell {
      padding: 10px 30px;
    }

    .van-cell__title {
      text-align: left;
    }
  }
}
</style>
